/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ratelimit_Toastdescguest3Inputs */

const he_ratelimit_toastdescguest3 = /** @type {(inputs: Ratelimit_Toastdescguest3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יותר מדי בקשות. התחבר לקבל פי 3 יותר גישה לגלישה.`)
};

const en_ratelimit_toastdescguest3 = /** @type {(inputs: Ratelimit_Toastdescguest3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many requests. Sign in to get 3× more browsing power.`)
};

/**
* | output |
* | --- |
* | "Too many requests. Sign in to get 3× more browsing power." |
*
* @param {Ratelimit_Toastdescguest3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const ratelimit_toastdescguest3 = /** @type {((inputs?: Ratelimit_Toastdescguest3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ratelimit_Toastdescguest3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_ratelimit_toastdescguest3(inputs)
	return en_ratelimit_toastdescguest3(inputs)
});
export { ratelimit_toastdescguest3 as "rateLimit_toastDescGuest" }